import Swal from 'sweetalert2';
import authHelper from './helpers/authHelper';
import { axiosErrorHandler, axiosResponseHandler, callTheApServerGet, callTheApServerPost } from './helpers/axiosHelper';
import { hydrateApBasicData } from './helpers/basicHelper';
import { addDNoneClass, byId } from './helpers/utility';





authHelper.validate();
hydrateApBasicData();
// checking query params for transition result alert













const gameNameInput = byId('gameNameInput');
const gameShortNameInput = byId('gameShortNameInput');
const gameBannerLinkInput = byId('gameBannerLinkInput');
const addNewGameSubmitBtn = byId('addNewGameSubmitBtn');







const addNewGameFun = () => {
    const data = {
        name: gameNameInput.value,
        shortName: gameShortNameInput.value,
        bannerLink: gameBannerLinkInput.value,
       
    };
    callTheApServerPost(`/basic/addNewGame`, { data: data }).then((response) => {
        axiosResponseHandler(response);
        const res = response.data;






        if (res.status === 'success') {
            console.log(res);


            Swal.fire({
                title: 'New Game added',
                icon: 'success',
                showConfirmButton: false,


                allowOutsideClick: false,


            });

            setTimeout(() => {
                location.reload();
            }, 3000);



        }
    }).catch((error) => {
        axiosErrorHandler(error);
        console.log(error);
    });
};

addNewGameSubmitBtn.addEventListener('click', addNewGameFun);

const deleteGamesFun = (sn) =>{
    callTheApServerGet(`/basic/deleteGame/${sn}`).then((response) => {
        axiosResponseHandler(response);
        const res = response.data;

        if (res.status === 'success') {
            console.log(res);


            Swal.fire({
                title: 'Game Deleted',
                icon: 'success',
                showConfirmButton: false,


                allowOutsideClick: false,


            });

            setTimeout(() => {
                location.reload();
            }, 3000);



        }
    }).catch((error)=>{
        axiosErrorHandler(error);
        console.log(error);
    });
};


window.deleteGamesFun=deleteGamesFun;

// get wallet history



const getGamesFun = () => {


    callTheApServerGet(`/basic/getGames`).then((response) => {
        axiosResponseHandler(response);
        const res = response.data;




        const gamesTableBodyElement = byId('gamesTableBodyElement');
        const gamesTableNoDataRowElement = byId('gamesTableNoDataRowElement');

        if (res.status === 'success') {
            console.log(res);

            const gamesData = res.gamesData;
            let i = 0;





            if (gamesData.length > 0) {

                addDNoneClass(gamesTableNoDataRowElement, true);


                while (i < gamesData.length) {
                    const {sn, name, shortName, bannerLink } = gamesData[i];

                    gamesTableBodyElement.innerHTML +=`
                    <tr>
                    
                        <td>${i + 1}</td>
                    
                        <td>${name}</td>
                        <td>${shortName}</td>
                      
                    
                        <td> <img class="img-fluid" src="${bannerLink}" alt="Game Banner" width="200"></td>
                     
                        <td><button class="btn btn-danger" onclick="deleteGamesFun(${sn})" >Delete</button></td>
                      
                    </tr>
                    `;
                    i++;
                }
            }

            if (gamesData.length === 0) {
                gamesTableNoDataRowElement.innerHTML = `
                <th class='text-center' colspan='6'>No Games Found 😥</th> 
                `;




            }



        }
    }).catch((error) => {
        axiosErrorHandler(error);
        console.log(error);
    });
};

getGamesFun();




